import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { ThemeMode } from '@/theme/theme';

/**
 * UI store for app-wide UI state.
 * 
 * Handles:
 * - Theme mode (light/dark)
 * - Sidebar open state
 * - Other UI preferences
 */

interface UIState {
  // Theme
  themeMode: ThemeMode;
  toggleTheme: () => void;
  setThemeMode: (mode: ThemeMode) => void;

  // Sidebar
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;

  // DataGrid page sizes (persist across navigation)
  refereesPageSize: number;
  setRefereesPageSize: (size: number) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Theme - default to system preference
      themeMode: 'light',
      toggleTheme: () =>
        set((state) => ({
          themeMode: state.themeMode === 'light' ? 'dark' : 'light',
        })),
      setThemeMode: (mode) => set({ themeMode: mode }),

      // Sidebar
      sidebarOpen: true,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      // DataGrid page sizes
      refereesPageSize: 25,
      setRefereesPageSize: (size) => set({ refereesPageSize: size }),
    }),
    {
      name: 'ui-storage',
    }
  )
);

